import { computed } from 'vue';
import { useEmailbotStore } from '@/stores/emailbot/emailbot';

export function useEmailBotItem() {
    const { EMAILBOT_PERMISSIONS, hasPermission } = useEmailbotStore();

    const hasAnyEmailbotAccess = computed(
        () =>
            hasPermission(EMAILBOT_PERMISSIONS.VIEW_EMAILBOT) ||
            hasPermission(EMAILBOT_PERMISSIONS.VIEW_COMMUNITY_TEMPLATE) ||
            hasPermission(EMAILBOT_PERMISSIONS.VIEW_CATEGORY)
    );

    const emailBotItems = computed(() => ({
        list: [
            {
                id: '__email_bot',
                label: 'Email bot',
                permissionChecker: hasAnyEmailbotAccess.value,
                items: [
                    {
                        icon: 'settings',
                        label: 'Configurations',
                        id: 'emailbot.configurations.index',
                    },
                    {
                        icon: 'file',
                        label: 'Templates',
                        id: 'emailbot.templates.index',
                    },
                ],
            },
        ],
    }));

    return { emailBotItems };
}
